@if (showToggle) {
  <div class="chatbot-floating-container">
    @if (isChatOpen) {
      <div class="chat-window-wrapper">
        <div class="chat-window-header">
          <span>AI Assistant</span>
          <div class="header-actions">
            <button mat-icon-button (click)="expandChat()" title="Pantalla completa">
              <mat-icon>open_in_full</mat-icon>
            </button>
            <button mat-icon-button (click)="toggleChat()">
              <mat-icon>close</mat-icon>
            </button>
          </div>
        </div>
        <div class="chat-window-content">
          <app-chatbot-main></app-chatbot-main>
        </div>
      </div>
    }

    <div class="chatbot-toggle-wrapper">
      <button mat-fab color="primary" (click)="toggleChat()" title="Hablar con la IA">
        <mat-icon>{{ isChatOpen ? 'forum' : 'auto_awesome' }}</mat-icon>
      </button>
    </div>
  </div>
}
